import { render, staticRenderFns } from "./HomePage4.vue?vue&type=template&id=6a3130d0&scoped=true&"
import script from "./HomePage4.vue?vue&type=script&lang=js&"
export * from "./HomePage4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3130d0",
  null
  
)

export default component.exports